import React from 'react';
import { TrendingDown, Banknote } from 'lucide-react';

/**
 * Секция формы для ввода параметров расходов
 */
const ExpenseParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      <h3 className="col-span-full text-lg font-medium text-gray-900 dark:text-white mb-2 flex items-center gap-2">
        <TrendingDown className="w-5 h-5 text-red-500" />
        Расходы
      </h3>
      
      {/* Расходы, связанные с производством и реализацией */}
      <div>
        <label htmlFor="expensesRelated" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Banknote className="w-4 h-4 mr-1 text-red-500" />
          Расходы, связанные с производством и реализацией
        </label>
        <input
          type="text"
          id="expensesRelated"
          name="expensesRelated"
          value={formData.expensesRelated}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.expensesRelated ? 'input-error' : ''}`}
          placeholder="Введите сумму"
        />
        {errors.expensesRelated && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.expensesRelated}
          </p>
        )}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Материальные, трудовые и прочие расходы на производство и реализацию
        </p>
      </div>

      {/* Внереализационные расходы */}
      <div>
        <label htmlFor="expensesOther" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Banknote className="w-4 h-4 mr-1 text-red-500" />
          Внереализационные расходы
        </label>
        <input
          type="text"
          id="expensesOther"
          name="expensesOther"
          value={formData.expensesOther}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.expensesOther ? 'input-error' : ''}`}
          placeholder="Введите сумму"
        />
        {errors.expensesOther && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.expensesOther}
          </p>
        )}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Расходы, не связанные с основной деятельностью (проценты по долгам, курсовые разницы, штрафы и т.д.)
        </p>
      </div>

      {/* Информационный блок */}
      <div className="col-span-full mt-2">
        <div className="p-3 bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-800 rounded-lg">
          <div className="flex items-start">
            <TrendingDown className="w-5 h-5 text-red-600 dark:text-red-400 mr-3 mt-0.5" />
            <div>
              <h4 className="text-sm font-medium text-red-700 dark:text-red-300 mb-1">
                О расходах для целей налогообложения
              </h4>
              <p className="text-xs text-red-600 dark:text-red-400">
                Согласно ст. 252 НК РФ расходами признаются обоснованные и документально подтвержденные затраты, осуществленные налогоплательщиком. Расходы делятся на расходы, связанные с производством и реализацией, и внереализационные расходы (ст. 253 НК РФ). Необходимо помнить, что некоторые расходы нормируются или не учитываются для целей налогообложения (перечень в ст. 270 НК РФ).
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseParametersSection;